import React from 'react'
import Layout from '../../Layout/Layout'
import gender1 from "../../images/gender1.PNG"
import gender2 from "../../images/gender2.PNG"

import { Link } from "react-router-dom";

const Gender_focus_program = () => {
  return (
   <Layout>
        <div className='uk-container'>
            <div><h2 className='light uk-text-bold uk-margin-xlarge-top'>Gender-Focused Programming / Intervention</h2></div>
            <div className='uk-grid  uk-margin-large-top'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>Moolu Venture Lab recognises that women across Africa continue
                         to face systemic barriers that limit their participation in entrepreneurship,
                          technology, and innovation spaces. These constraints—ranging from limited 
                          access to capital and networks to entrenched socio-cultural norms—reduce 
                          the pipeline of women-led ventures able to scale and compete globally.
                           Our gender-focused programming is therefore designed to dismantle these
                            barriers by creating intentional pathways for women to lead, innovate, and grow. 
</p>

                <p className='light'>We adopt a context-specific approach that reflects the unique
                     realities of women entrepreneurs in Nigeria and across the continent. By
                      embedding gender inclusivity at the core of our mission, we work to ensure
                       equitable participation in all our programmes. This commitment guides our
                        strategy, partnerships, and long-term investment in women’s economic empowerment.</p>

                        <p className='light'>Moolu Venture Lab delivers targeted interventions that address the
                             foundational gaps women often face in business development, digital 
                             literacy, leadership, and access to markets. Through specialised training, 
                             mentorship pipelines, and bespoke capacity-building sessions, our programmes 
                             strengthen women’s technical and entrepreneurial competency, enabling them 
                             to build resilient, investment-ready ventures. We collaborate closely with 
                             stakeholders—government entities, corporate partners, and development 
                             organisations—to design inclusive curricula and learning pathways</p>
               </div>

                <div className='uk-width-1-2@s'>
                  <img src={gender1} />
               </div>
            </div>




          <div className='uk-grid  uk-margin-large-top'>
               <div className='uk-width-1-2@s'>
                  <img src={gender2}/>
               </div>

                <div className='uk-width-1-2@s'>
                     <p className='light'>These interventions are complemented by community-building
                         activities that foster peer support and long-term relationship networks.
                          Our approach ensures that participants not only develop skills but also
                           gain confidence and visibility. Over time, this model expands the
                            number of high-potential female innovators positioned to transform their sectors. 
</p>

                <p className='light'>To further drive gender equity, Moolu Venture Lab integrates
                     gender-responsive investment facilitation and post-programme support that 
                     ensure women founders continue to scale after initial incubation. We work
                      to improve access to finance by connecting women-led enterprises with 
                      investors, grantmakers, and blended-finance instruments tailored to 
                      overcome gender-based capital constraints. In addition, we support 
                      partners to embed gender considerations across policy design, 
                      technology adoption, and organisational culture. 
                      Our monitoring and evaluation frameworks incorporate gender
                       indicators that track progress, impact, and long-term outcomes
                        for women beneficiaries. </p>

                        

                       
               </div>
            </div>


            <div className='uk-grid uk-margin-large-top'>
                   <div className='uk-width-1-2@s'>
  <p className='light'>To further drive gender equity, Moolu Venture Lab integrates
                     gender-responsive investment facilitation and post-programme support that 
                     ensure women founders continue to scale after initial incubation. We work
                      to improve access to finance by connecting women-led enterprises with 
                      investors, grantmakers, and blended-finance instruments tailored to 
                      overcome gender-based capital constraints. In addition, we support 
                      partners to embed gender considerations across policy design, 
                      technology adoption, and organisational culture. 
                      Our monitoring and evaluation frameworks incorporate gender
                       indicators that track progress, impact, and long-term outcomes
                        for women beneficiaries. </p>
                   </div>

                    <div className='uk-width-1-2@s'>
 <p className='light'>By championing inclusive innovation ecosystems and supporting
                             partners to adopt gender-sensitive practices, Moolu Venture Lab contributes 
                             to stronger, more equitable economic growth. Ultimately, our vision is to build
                              a future where women’s leadership and innovation are central to Africa’s 
                              sustainable development.</p>

                              <p className='light'>An example of some our gender focesed programming is the <Link to="/wira"> women investment readiness accelerators program.</Link></p>
                   </div>
            </div>




        </div>
        </Layout>
  )
}

export default Gender_focus_program